import css from 'styled-jsx/css';

export const GoogleAdsStyles = css`
  .ad-component-top {
    margin-bottom: 5px;
    display: inline-block;
  }
  .ad-component-side {
    margin-top: 5px;
    display: inline-block;
  }
  .ad-component-bottom {
    margin-top: 50px;
    margin-bottom: 40px;
  }
`;
